const translations = {
    'deposit.gold': 'złoże złota',
    'deposit.iron': 'złoże żelaza',
    'deposit.stone': 'złoże kamienia',
};

export default translations;
